export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20illustration%20of%20a%20cozy%20reading%20nook%20with%20manga%20books%20scattered%20around%20soft%20warm%20lighting%20from%20a%20nearby%20lamp%20a%20comfortable%20armchair%20with%20a%20plush%20blanket%20magical%20floating%20book%20pages%20with%20tiny%20illustrations%20escaping%20from%20them%20gentle%20atmospheric%20scene%20with%20warm%20golden%20and%20cream%20tones%20peaceful%20vibe&width=800&height=600&seq=about-brand-01&orientation=landscape"
                alt="关于妖精漫画网 - 舒适的漫画阅读体验"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">
              关于妖精漫画
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                妖精漫画网成立于2020年，是国内领先的漫画在线阅读平台之一。我们致力于为漫画爱好者提供
                安全、快速、优质的阅读体验，涵盖奇幻、魔幻、萌系等多种热门题材。
              </p>
              <p>
                平台采用先进的页面加载技术，支持流畅的下拉式阅读模式，让读者无需翻页即可沉浸式追更。
                每天稳定更新多部热门连载，确保追更节奏不断档。
              </p>
              <p>
                我们与众多优秀漫画作者紧密合作，持续扩充内容库，为读者带来最新、最全的漫画作品。
                无论您是喜欢热血冒险还是治愈日常，妖精漫画网都能满足您的阅读喜好。
              </p>
            </div>

            <div className="flex flex-wrap gap-4 mt-7">
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-primary-50 text-primary-700 text-sm">
                <i className="ri-shield-check-line"></i>
                <span>安全无广告</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-accent-50 text-accent-700 text-sm">
                <i className="ri-speed-up-line"></i>
                <span>极速加载</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-secondary-50 text-secondary-700 text-sm">
                <i className="ri-book-open-line"></i>
                <span>海量漫画库</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}